//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormDrawer from './components/FormDrawer.vue'
import EditDrawer from './components/EditDrawer.vue'
import { venues_list, timeSlot_list, timeSlot_del } from '@/apis/stadium'


export default {
    components: {
        FormDrawer,
        EditDrawer
    },
    data() {
        return {
            showFormDrawer: false,
            showEditDrawer: false,
            data: [],
            config: {
                gymnasiums: []
            },
            form: {
                venueCode: undefined,
                fieldCode: '',
                sDate: '',
                eDate: '',
                pageNumber: -1,
                pageSize: 9999
            },
            isLoading: false,
            showAddForm: false,
            formState: {
                options: '0'
            },
            editDefaultParams: {
                id: ''
            },
            formDefaultParams: {
                date: '',
                venueCode: '',
            }
        }
    },
    mounted() {
        this.onPageConfig();
    },
    methods: {
        async onPageConfig() {
            try {
                //加載所屬場館
                const res = await venues_list({ venueName: '', venueCode: '', venueState: '1', pageNumber: 1, pageSize: 999 });
                this.config.gymnasiums = res.data.records;

                var now = new Date();
                const firstDay = this.$moment(new Date(new Date(now.getFullYear(), now.getMonth(), 1))).format('YYYY-MM-DD');
                const lastDay = this.$moment(new Date(now.getFullYear(), now.getMonth() + 1, 0)).format('YYYY-MM-DD');
                this.form.sDate = firstDay;
                this.form.eDate = lastDay;
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad() {
            if ((this.form.venueCode || '') == '')
                return;

            try {
                this.isLoading = true;
                const res = await timeSlot_list(this.form) || {};
                if (res.code == 0) {
                    this.data = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.isLoading = false;
            }
        },
        getDayEventList(value) {
            //console.log(value, this.data);
            if (this.data.length > 0) {
                return this.data.filter(item => item.time == value.format('YYYY-MM-DD'));
            } else {
                return [];
            }
        },
        getEventRow(item) {
            return `${item.name} ${item.fieldName} ${this.$moment(item.startTime, "HH:mm:ss").format('HH:mm')}-${this.$moment(item.endTime, "HH:mm:ss").format('HH:mm')}`
        },
        handleSearchSubmit() {
            if (this.form.venueCode) {
                this.onPageLoad();
            } else {
                this.$message.error('請先選擇場館');
            }
        },
        handlePanelChange(value, mode) {
            console.log('handlePanelChange', value, mode);
            const date = this.$moment(value, 'YYYY-MM-DD');
            const firstDay = date.clone().date(1).format('YYYY-MM-DD');
            const lastDay = date.clone().endOf('month').format('YYYY-MM-DD');
            this.form.sDate = firstDay;
            this.form.eDate = lastDay;
            this.onPageLoad();

        },
        handleCalendarSelect(value) {
            console.log(value);
        },
        handleChooseMatches(item) {
            console.log(item);
        },
        handleEditMatches(item) {
            console.log('edit', item);
            if (item.orderNumberTotal > 0) {
                this.$confirm({
                    title: '警告',
                    content: '已有會員購買了該場次，如果進行修改會進行LINE通知',
                    okText: '確認',
                    cancelText: '取消',
                    onOk: () => {
                        this.showEditDrawer = true;
                        this.editDefaultParams = {
                            id: item.id
                        }
                    }
                });
            } else {
                this.showEditDrawer = true;
                this.editDefaultParams = {
                    id: item.id
                }
            }
        },
        handleAddMatches(value) {
            this.formDefaultParams = {
                date: value, venueCode: this.form.venueCode
            }
            this.showFormDrawer = true;
        },
        handleNotDeleteMessage() {
            this.$message.warning('會員已購買，不可刪除');
        },
        async handleDeleteMatches(item) {
            if (item.orderNumberTotal > 0) {
                this.$message.warning('會員已購買，不可刪除');
            } else {
                try {
                    const res = await timeSlot_del(item.id);
                    if (res.code == 0) {
                        this.onPageLoad();
                    } else {
                        if (res.msg)
                            throw new Error(res.msg);
                    }
                } catch (error) {
                    this.$message.error(error.message);
                }
            }
        },
        onFormSubmit() {
            this.showFormDrawer = false;
            this.onPageLoad();
        },
        onEditSubmit() {
            this.showEditDrawer = false;
            this.onPageLoad();
        },

        // toDetails(id) {
        //     this.$router.push(`/matches-block/${id}`);
        // },
        // toInstallForm() {
        //     this.$router.push(`/matches-block/add`);
        // },
        // toEdit(id) {
        //     this.$router.push(`/matches-block/edit/${id}`);
        // }
    }
}
